import axios from 'axios';
import * as types from '../../actions/actionTypes';
import * as agentinfo from '../../actions/upload-contract-actions/upload-contract-actions';
import * as constants from '../../../constants/constants';
import { history } from '../../history';
import { LOGOUT } from '../../actions/actionTypes';
import { getToken } from '../aws/token';

const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || 'https://apidmz.fpl.com';
// 'http://localhost:8080';

let REQUEST_TYPE = 'application/json';
let sendEmailEndpoint = `${API_ENDPOINT}/v1/surety-bond/sendemail`;
let authHeader =
  'Authorization, Origin, X-Requested-With, content-Type, Accept';
export const setFileFromS3 = (fileName, bondNo, file, authToken, onSuccess) => {
  let token = authToken || getToken();
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileName', fileName);
  formData.append('bondNo', bondNo);
  console.log('Upload file ', token);
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Credentials': 'true',
      Authorization: `Bearer ` + token,
    },
    crossorigin: true,
  };
  let config1 = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      Authorization: `Bearer ` + token,
    },
    crossorigin: true,
  };
  console.log('Authorization-token', token);
  return dispatch => {
    dispatch({ type: types.SET_REMOVE_ERROR });
    dispatch(agentinfo.setUploadPending(true));
    axios
      .post(
        `${API_ENDPOINT}/v1/surety-bond/customer/uploadAssumeS3`,
        formData,
        config,
      )
      .then(response => {
        dispatch(agentinfo.setUploadSuccess(false, response.data, file));
        onSuccess();
        return axios
          .all([
            axios.post(
              sendEmailEndpoint,
              {
                subject: constants.depAdminSubject(
                  response.data.district,
                  response.data.appStatus,
                ),
                templateName: constants.DEPOSIT_ADMIN_EMAIL_TEMPLATE_NAME,
                bondNumber: response.data.bondNumber,
                billAccount: response.data.billAccount,
                companyName: response.data.companyName,
                district: response.data.district,
                status: response.data.appStatus,
                emailAddress: constants.DepsoitAdminEmail,
              },
              config1,
            ),
          ])
          .then(
            axios.spread((firstResponse, secondResponse) => {
              console.log(firstResponse.data, secondResponse.data);
            }),
          );
      })
      .catch(error => {
        console.log('service call failied', error.response.data);
        if (error.response.status === 503) {
          dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-AG-SVS-APIGEE-DOWN'));
          history.push('/error');
        } else if (error.response.status === 409) {
          dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-DB-DOWN'));
          history.push('/error');
        } else if (error.response.status === 500) {
          dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-UP-SERV-DOWN'));
          history.push('/error');
          dispatch(agentinfo.setUploadError(false, error));
        } else if (error.status === 401 || error === 'Network Error') {
          dispatch({
            type: LOGOUT,
          });
        } else {
          dispatch(
            agentinfo.setUploadError(false, error.response.data.message),
          );
        }
      });
  };
};

export const deleteFileFromS3 = (fileName, bondNo, authToken, onSuccess) => {
  let token = authToken || getToken();

  let config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers':
        'Authorization, Origin, X-Requested-With, content-Type, Accept',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Credentials': 'true',
      Authorization: `Bearer ` + token,
      fileName: fileName,
      bondNo: bondNo,
    },
    crossorigin: true,
  };
  console.log('Authorization-token', token);
  return dispatch => {
    dispatch({
      type: types.SET_REMOVE_UPLOAD_ERROR,
    });
    dispatch(agentinfo.setUploadPending(true));
    axios
      .delete(`${API_ENDPOINT}/v1/surety-bond/customer/deleteFile`, config)
      .then(response => {
        dispatch(agentinfo.setDeleteSuccess(false, response.data));
        onSuccess();
      })
      .catch(err => {
        console.log('service call failied', err);
        if (err.response.status === 503) {
          dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-AG-SVS-APIGEE-DOWN'));
          history.push('/error');
        } else if (err.response.status === 409) {
          dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-DB-DOWN'));
          history.push('/error');
        } else if (err.response.status === 500) {
          dispatch(agentinfo.setErrorPage(false, 'ERR:NCP-DEL-SERV-DOWN'));
          history.push('/error');
          dispatch(agentinfo.setUploadError(false, err));
        } else if (err.status === 401 || err === 'Network Error') {
          dispatch({
            type: LOGOUT,
          });
        } else if (err.message !== undefined) {
          dispatch(agentinfo.setUploadError(false, err.message));
        } else {
          dispatch(agentinfo.setUploadError(false, err));
        }
      });
  };
};
